export default __webpack_public_path__ + "e5fe4f7.png";